module.exports = __webpack_public_path__ + "img/pro-photo3.995cc023.png";